import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { lazy } from "react";
import { Pencil } from "lucide-react";

const NoteDeFraisForm = lazy(() =>
  import("@/features/rh/notes-de-frais/components/NoteDeFraisForm").then((m) => ({
    default: m.default,
  })),
);

export const Route = createFileRoute("/_app/(dashboard)/frais/$id/edit")({
  loader: requirePermission(PERMISSIONS.RH.FRAIS?.EDIT || "rh.frais.edit"),
  staticData: {
    title: "Modifier une note de frais",
    icon: Pencil,
    permission: PERMISSIONS.RH.FRAIS?.EDIT || "rh.frais.edit",
    section: "App",
    showInBreadcrumb: true,
  },
  component: () => {
    const { id } = useParams({ from: "/_app/(dashboard)/frais/$id/edit" });
    return (
      <NoteDeFraisForm
        routeFrom="/_app/(dashboard)/frais/$id/edit"
        backTo="/frais/me"
        editMode
        noteId={id}
        hidePersonne
      />
    );
  },
});